import { Component } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "app-terms-and-conditions",
  standalone: true,
  templateUrl: "./terms-and-conditions.component.html",
  styleUrl: "./terms-and-conditions.component.scss",
  imports: [TranslateModule],
})
export class TermsAndConditionsComponent {}
